module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-prerolls-icon-2-a24fe3236b8446bc539793741ba5a0fe.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/elo-app/img/category_icons/menu-prerolls-icon-2.svg
 ** module id = 1007
 ** module chunks = 1 75
 **/